/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */
/* eslint-disable camelcase */
/* eslint-disable no-restricted-syntax */
/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable arrow-body-style */
/* eslint-disable prefer-destructuring */
/* eslint-disable camelcase */
/* eslint-disable no-plusplus */
import * as React from 'react';
// import { useRef } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useState, useEffect, useRef } from 'react';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import {
  Container,
  TextField,
  Autocomplete,
  FormControl,
  Stack,
  useTheme,
  Grid,
  Snackbar,
  Alert,
  Slide,
  Dialog,
  LinearProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableBody,
  Checkbox,
  TableCell,
  InputLabel,
  Select,
  MenuItem,
  Paper,
  AccordionDetails,
  AccordionSummary,
  Accordion,
} from '@mui/material';
import tableCellClasses from '@mui/material/TableCell';
import styled from '@emotion/styled';
import { Link, useNavigate, useParams } from 'react-router-dom';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import noimge from '../../media/noimge.png';
import '../stylemod.css';
import axios from '../../axiosConfig';

const useStyles = styled((theme) => ({
  fileInput: {
    display: 'none',
  },
  chooseFileButton: {
    marginRight: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableHeader = styled(TableCell)(({ theme }) => ({
  // backgroundColor: theme.palette.info.main,
  backgroundColor: '#8EACCD',
  color: theme.palette.common.white,
  border: '1px solid white',
}));

function formatDate(inputDateTime) {
  const isoDate = new Date(inputDateTime);

  const day = isoDate.getUTCDate().toString().padStart(2, '0');
  const month = (isoDate.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = isoDate.getUTCFullYear();

  let hour = isoDate.getUTCHours();
  const ampm = hour >= 12 ? 'PM' : 'AM';
  hour %= 12;
  hour = hour || 12;

  const minute = isoDate.getUTCMinutes().toString().padStart(2, '0');

  return `${day}/${month}/${year}`;
}

export default function AddPRProduction() {
  const { id } = useParams();
  const { type } = useParams();
  const theme = useTheme();
  // console.log(id, 'type is', type);
  const classes = useStyles();
  const navigate = useNavigate();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const tokent =
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJldmVudGxpc3QiOlt7IlVzZXJJRCI6IjEiLCJMb2dpbkNvZGUiOiIwMSIsIkxvZ2luTmFtZSI6IkFkbWluIiwiRW1haWxJZCI6ImFkbWluQGdtYWlsLmNvbSIsIlVzZXJUeXBlIjoiQURNSU4ifV0sImlhdCI6MTYzODM1NDczMX0.ZW6zEHIXTxfT-QWEzS6-GuY7bRupf2Jc_tp4fXIRabQ';
  // OPERATIONAL REQUIREMNETS STATES
  const [openDelete, setOpenDelete] = useState(false);
  const [SCRValue, setSCRValue] = useState('');
  const [currentDate, setCurrentDate] = React.useState(new Date());
  const [headerData, setHeaderData] = useState(null);
  const [operationSelected, setoperationSelected] = React.useState('');
  const [OperationDataOption, setOperationDataOption] = useState([]);
  const [userData, setUserData] = useState([]);
  const [AllUsersData, setAllUsersData] = useState([]);
  const [userselected, setUserSelected] = React.useState('');
  const [Pcs, setPcs] = React.useState('');
  const [styleNum, setStyleNum] = React.useState('');
  const [remarks, setRemarks] = React.useState('');
  const [unitData, setUnitData] = useState([]);
  const [unitSelected, setUnitSelected] = React.useState('');
  const [lineData, setLineData] = useState([]);
  const [lineSelected, setLineSelected] = React.useState('');
  const [selectedImageFile, setSelectedImageFile] = useState('');
  const [imagePreview, setImagePreview] = useState('');

  // ADD OPRATIONS STATES
  const [opGroupSelected, setOpGroupSelected] = useState({ op_group_name: 'All Groups' });
  const [selectedOperations, setSelectedOperations] = useState([]);
  const [OperationData, setOperationData] = useState([]);
  const [opGroupData, setOpGroupData] = useState([]);
  const [operationDetails, setOperationDetails] = useState([]);

  // others
  const [FinalPr, setFinalPr] = useState(false);
  const [alertType, setAlertType] = useState('success');
  const [openAlert, setopenAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  const [openLoader, setOpenLoader] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [machineData, setMachineData] = useState([]);
  const [HoursData, setHoursData] = useState([]);
  const [Scrid, setScrid] = useState('');
  const autocompleteRef = useRef(null);
  const [allRecordsData, setallRecordsData] = useState([]);
  const [idState, setIdState] = useState(id);
  const [obSelected, setObSelected] = React.useState(null);
  const [isDisabled, setIsDisabled] = React.useState(false);
  const [isDisabled1, setIsDisabled1] = React.useState(false);

  const formatDateToinitialValues = (date) => {
    if (!date) {
      return '';
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  const initialFromDate = formatDateToinitialValues(new Date());
  const [date, setDate] = useState(initialFromDate);
  const [fieldErrors, setFieldErrors] = React.useState({
    // opertional requirements
    operationSelected: false,
    userselected: false,
    Pcs: false,
    styleNum: false,
    lineSelected: false,
    remarks: false,
    unitSelected: false,
  });

  const resetFields = () => {
    setoperationSelected(null);
    setUserSelected(null);
    setPcs('');
    // setStyleNum('');
    // setRemarks('');
    // setLineSelected('');
  };

  const handleDeleteConfirmed = (admId) => {
    setObSelected(SCRValue);
    Gethours(SCRValue.Srhid, date);
    setIdState(SCRValue.Srhid);
    setTableData([]);
    setInsertDataDetail([]);
    setOpenDelete(false);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
    setopenAlert(false);
  };
  // handling image file
  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5 MB (adjust as needed)
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png'];

  const handleFileChange = (event, fileType) => {
    const file = event.target.files[0];

    // File size validation
    if (file.size > MAX_FILE_SIZE) {
      alert('File size exceeds the maximum allowed size (5 MB).');
      return;
    }

    // File type validation
    if (!ALLOWED_FILE_TYPES.includes(file.type)) {
      alert('Invalid file type. Allowed types are JPEG, PNG, and PDF.');
      return;
    }

    // Update the selected file and error state based on the fileType
    if (fileType === 'photo') {
      setSelectedImageFile(file);
      setImagePreview(URL.createObjectURL(file));
      setFieldErrors((prevFieldErrors) => ({ ...prevFieldErrors, selectedImageFile: false }));
    }
  };

  // API Integration
  React.useEffect(() => {
    GetAllSRC();
    // console.log(id, 'type is', type);
    GetAllOperationMstData();
    GetAllMachineMstData();
    // GetAllActiveBuyers();
    if (!id) {
      GetAllUser();
    }

    GetAllActiveOperationGrpData();
    GetAllActiveLineMstData();
    GetAllActiveProductionUnits();
  }, []);

  // get all Operation Request
  const GetAllOperationMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationMst', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOperationData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {}, [searchTerm]);

  const filteredData = OperationData.filter((enq) => {
    const searchTermLowerCase = searchTerm.toLowerCase();
    return Object.values(enq).some((value) => {
      if (typeof value === 'string') {
        return value.toLowerCase().includes(searchTermLowerCase);
      }
      return false;
    });
  });

  // get all unit data
  const GetAllActiveProductionUnits = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setUnitData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all Operation Request
  const GetAllUser = async (data) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllUsers/N', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const usersdatas = res.data;
      setUserData(res.data);
      setAllUsersData(res.data);

      if (id) {
        const filteredUserdata = usersdatas.filter(
          (user) => !data.some((item) => Number(item.Operatorid) === Number(user.UserAccessID))
        );
        // console.log(filteredUserdata,usersdatas,'filteredUserdata edit',)
        setUserData(filteredUserdata);
      }

      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all group Request
  const GetAllActiveOperationGrpData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllActiveOperationGrpData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setOpGroupData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all machine data
  const GetAllMachineMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetAllMachineMstData', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setMachineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // get all line data
  const GetAllActiveLineMstData = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`/GetAllActiveLineMstData/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      setLineData(res.data);
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleCloseAlert = () => {
    setopenAlert(false);
  };

  // pre fill data for editing screen
  useEffect(() => {
    const GetoneObHeader = async (ids) => {
      GetOperationBasedSRC(ids);
      setOpenLoader(true);
      try {
        const res = await axios.instance.get(`GetoneStyleRateHearder/${ids}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        // const data = res.data;
        setHeaderData(res.data[0]);
        console.log(res.data);
        const data = res.data;
        data.forEach((editDataonID) => {
          const { Unit_Id } = editDataonID;
          const selectedunit = unitData.find((obj) => Number(obj.Unit_Id) === Number(Unit_Id));
          setUnitSelected(selectedunit);
        });
        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setOpenLoader(false);
      } finally {
        setOpenLoader(false);
      }
    };

    if (!id && idState) {
      GetoneObHeader(idState);
    }
  }, [idState]);

  const Gethours = async (ids, prdate) => {
    try {
      const response = await axios.instance.get(`Getallhr/${ids}/PR`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });

      const data = response.data;

      // Filter data by prdate
      const filteredData = data.filter((datas) => formatDate(datas.Prdate) === formatDate(prdate));
      console.log(filteredData, data, formatDate(prdate), 'filteredData');
      let lastdate = '';
      let values = '';
      const hours = [];

      if (!id) {
        if (filteredData.length === 0) {
          setSelectedHour('H1');

          setHoursData([]);
        } else {
          for (const datas of filteredData) {
            lastdate = datas.CreatedDate;
            values = datas.prhrs;
            hours.push(datas);
          }

          setHoursData(hours);

          const startFrom = values || 'H0';

          if (startFrom.startsWith('H')) {
            const hourValue = parseInt(startFrom.slice(1), 10);
            setSelectedHour(`H${Math.min(hourValue + 1, 12)}`);
          }
        }
      } else {
        setHoursData(filteredData);
      }

      console.log(hours, 'hours');
    } catch (error) {
      console.error('Error fetching hours:', error);
    }
  };

  const GetoneObHeaderEdit = async (ids) => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get(`GetoneStyleRateHearder/${ids}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      // const data = res.data;
      // setHeaderData(res.data[0]);

      setFinalPr(res.data[0].prcompleted === 'Y');
      setIsDisabled(res.data[0].prcompleted === 'Y');
      setIsDisabled1(res.data[0].prcompleted === 'Y');
      const resUnit = await axios.instance.get(`/GetAllActiveProductionUnits/${sessionStorage.getItem('UserID')}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      const data = res.data;
      const Unit = resUnit.data;
      data.forEach((editDataonID) => {
        const { Unit_Id } = editDataonID;
        const selectedunit = Unit.find((obj) => Number(obj.Unit_Id) === Number(Unit_Id));
        console.log(selectedunit, 'selectedunit');
        setUnitSelected(selectedunit);
      });
      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setOpenLoader(false);
    } finally {
      setOpenLoader(false);
    }
  };

  useEffect(() => {
    const GetoneHeader = async (ids) => {
      setOpenLoader(true);
      try {
        const res = await axios.instance.get(`Getoneprheader/${id}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        console.log('API response:', res.data);
        setHeaderData(res.data[0]);
        const data = res.data;
        data.forEach((editDataonID) => {
          const { Srhid, Prdate } = editDataonID;
          GetoneObHeaderEdit(Srhid);
          GetOperationBasedSRC(Srhid);
          setScrid(Srhid);
          setDate(editDataonID.Prdate);
          setSelectedHour(editDataonID.prhrs);
          setObSelected({
            Srhid: editDataonID.Srhid,
            StyleDescription: editDataonID.StyleDescription,
            SrhNo: editDataonID.SrhNo,
          });
          Gethours(editDataonID.Srhid, editDataonID.Prdate);
          console.log(editDataonID.Prdate);
        });

        setOpenLoader(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setOpenLoader(false);
      } finally {
        setOpenLoader(false);
      }
    };

    if (id) {
      GetoneHeader();
    }
  }, []);

  const getonedetails = async (data) => {
    try {
      const res = await axios.instance.get(`Getoneprdetail/${id}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      // console.log('API response:', res.data);
      const datas = res.data;
      setTableData(res.data);
      setInsertDataDetail(res.data);

      const filterdata = data.filter((obj) => !datas.some((obj1) => obj1.Operationid === obj.Operationid));
      setOperationDataOption(filterdata);

      GetAllUser(datas);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // Updated form validation functions
  const validateOpeartinRequirements = () => {
    const errors = {
      operationSelected: !operationSelected,
      userselected: !userselected,
      Pcs: !Pcs,
      styleNum: !styleNum,
      lineSelected: !lineSelected,
      remarks: !remarks,
      selectedImageFile: !selectedImageFile,
      unitSelected: !unitSelected,
    };
    setFieldErrors((prevFieldErrors) => ({ ...prevFieldErrors, ...errors }));
    return !Object.values(errors).some(Boolean);
  };

  const handleFormSubmit = () => {
    console.log();
    // if (!validateOpeartinRequirements()) {
    //   return;
    // console.log((tableData.filter((data) =>  data.Pieces === 0)))
    if (
      tableData.filter((data) => Number(data.Pieces) === 0).length === 0 &&
      tableData.filter((data) => Number(data.Operatorid) !== 0).length === tableData.length
    ) {
      if (!id) {
        addNewOB();
      } else {
        updateOB(id);
      }
    } else {
      if (tableData.filter((data) => Number(data.Pieces) === 0).length !== 0) {
        alert('Please enter Pieces');
      }
      if (tableData.filter((data) => Number(data.Operatorid) !== 0).length !== tableData.length) {
        alert('Please select Operator');
      }
    }
  };

  const addNewOB = () => {
    // console.log(headerData, 'headerData');

    setOpenLoader(true);

    return axios.instance
      .post(
        '/InsertPrheader',
        {
          Srhid: headerData.Srhid,
          Prdate: date,
          StyleDescription: headerData.StyleDescription,
          StyleNumber: headerData.StyleNumber,
          GarmentDescription: headerData.GarmentDescription,
          Batchline: headerData.Batchid,
          prhrs: selectedHour,
          CreatedBy: sessionStorage.getItem('UserID'),
          Prcompleted: FinalPr ? 'Y' : 'N',
          CompanyId: sessionStorage.getItem('CompanyId'),
          FiscalYear: sessionStorage.getItem('FiscalYear'),
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        }
      )
      .then((headerRes) => {
        if (headerRes.data && headerRes.data.length > 0 && headerRes.data[0].PRheaderid !== undefined) {
          const PRheaderid = headerRes.data[0].PRheaderid;
          console.log(tableData);
          const detailPromises = tableData.map((obj, index) => {
            const insertData = {
              ...obj,
              PRheaderid,
              PRsno: index + 1,
            };

            // Log individual insertData for debugging
            console.log('Insert data for each detail:', insertData);

            return axios.instance.post('/InsertPrdetail', insertData, {
              headers: {
                Authorization: tokent,
                'Content-Type': 'application/json',
              },
            });
          });

          // Log the detailPromises array after it's been fully constructed
          console.log('detailPromises', detailPromises);

          return Promise.all(detailPromises)
            .then((detailRes) => {
              setAlertType('success');
              setAlertMessage('Data Added Successfully!');
              setopenAlert(true);
              resetFields();
              setTimeout(() => {
                setopenAlert(false);
                setOpenLoader(false);
                navigate('/dashboard/manage/pr_production');
              }, 2000);
              return detailRes;
            })
            .catch((error) => {
              console.error('Error adding detail data:', error);
              setAlertType('error');
              setAlertMessage('Failed to add detail data.');
              setOpenLoader(false);
              setopenAlert(true);
              return Promise.reject(error);
            });
        }
        setAlertType('error');
        setAlertMessage("Oops! Can't add this data...");
        setopenAlert(true);
        setOpenLoader(false);
        return Promise.reject(new Error('Header insert failed'));
      })
      .catch((error) => {
        console.error('Error adding new Data:', error);
        setAlertType('error');
        setAlertMessage('Failed to add the new Data.');
        setOpenLoader(false);
        setopenAlert(true);
        return Promise.reject(error);
      });
  };

  // put Request to edit record
  const updateOB = async (id, newData) => {
    setOpenLoader(true);
    console.log(headerData, 'headerData');

    return axios.instance
      .put(
        `/Updateprheader/${id}`,
        {
          Srhid: headerData.Srhid,
          Prdate: date,
          StyleDescription: headerData.StyleDescription,
          StyleNumber: headerData.StyleNumber,
          GarmentDescription: headerData.GarmentDescription,
          Batchline: headerData.Batchline,
          prhrs: selectedHour,
          Prcompleted: FinalPr ? 'Y' : 'N',
          ModifyedBy: 1,
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        }
      )
      .then((headerRes) => {
        if (headerRes.data && headerRes.data.length > 0 && headerRes.data[0].PRheaderid !== undefined) {
          const PRheaderid = headerRes.data[0].PRheaderid;

          console.log(InsertDataDetail, 'InsertDataDetail');

          const detailPromises = InsertDataDetail.map((obj) => {
            const insertData = {
              ...obj,
              PRheaderid,
              PRsno: obj.PRsno,
            };

            // Log individual insertData for debugging
            console.log('Insert data for each detail:', insertData);

            return axios.instance.post('/InsertPrdetail', insertData, {
              headers: {
                Authorization: tokent,
                'Content-Type': 'application/json',
              },
            });
          });

          // Log the detailPromises array after it's been fully constructed
          console.log('detailPromises', detailPromises);

          return Promise.all(detailPromises)
            .then((detailRes) => {
              setAlertType('success');
              setAlertMessage('Data Added Successfully!');
              setopenAlert(true);
              resetFields();
              setTimeout(() => {
                setopenAlert(false);
                setOpenLoader(false);
                navigate('/dashboard/manage/pr_production');
              }, 2000);
              return detailRes;
            })
            .catch((error) => {
              console.error('Error adding detail data:', error);
              setAlertType('error');
              setAlertMessage('Failed to add detail data.');
              setOpenLoader(false);
              setopenAlert(true);
              return Promise.reject(error);
            });
        }
        setAlertType('error');
        setAlertMessage("Oops! Can't add this data...");
        setopenAlert(true);
        setOpenLoader(false);
        return Promise.reject(new Error('Header insert failed'));
      })
      .catch((error) => {
        // Handle error during header insertion
        console.error('Error adding new Data:', error);
        setAlertType('error');
        setAlertMessage('Failed to add the new Data.');
        setOpenLoader(false);
        setopenAlert(true);
        return Promise.reject(error);
      });
  };

  const handleInputChangeMachineSelect = (index, newValue) => {
    handleDetailChange(index, 'Mctypeid', newValue ? newValue.Machine_Id : null);
  };

  const handleCheckboxChange = (operationId) => {
    setSelectedOperations((prevState) =>
      prevState.includes(operationId) ? prevState.filter((id) => id !== operationId) : [...prevState, operationId]
    );
  };

  const filteredOperations =
    opGroupSelected.op_group_name === 'All Groups'
      ? OperationData
      : OperationData.filter((obj) => obj.op_group_name === opGroupSelected.op_group_name);

  const handleAddOperations = () => {
    const newAddedOperations = OperationData.filter((operation) => selectedOperations.includes(operation.OperationId));

    const newOperationDetails = newAddedOperations.map((operation) => {
      const selectedMachineObj = machineData.find((obj) => obj.Machine_Id === operation.Machine_Id);

      console.log(operation);
      return {
        Operationid: operation.OperationId,
        OperationName: operation.OperationName,
        OperationGroup: operation.op_group_name,
        Mctypeid: selectedMachineObj ? selectedMachineObj.Machine_Id : null,
        noOFWS: operation.emp_role,
        RateOnMale: operation.RateOnMale === null ? null : operation.RateOnMale,
        RateOnFemale: operation.RateOnFeMale === null ? null : operation.RateOnFeMale,
        SPI: selectedMachineObj.Stitch_per_Inch,
        RMP: selectedMachineObj.RMP,
        CreatedBy: sessionStorage.getItem('UserID'),
      };
    });

    setOperationDetails((prevState) => [...prevState, ...newOperationDetails]);
    setSelectedOperations([]);
    setDialogOpen(false);
  };

  const [tableData, setTableData] = React.useState([]);

  const [InsertDataDetail, setInsertDataDetail] = useState([]);

  const GetoneSRC = async (opert) => {
    await axios.instance
      .get(`/GetoneStyleRateDetail/${Scrid}`, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'application/json',
        },
      })
      .then((res) => {
        const result = [];
        const arryanew = res.data;

        arryanew.forEach((operation) => {
          for (let i = 0; i < operation.noOFWS; i++) {
            result.push({ ...operation });
          }
        });
        const operatorCount = {};
        const operatorFirstIndex = {};

        // Count occurrences of each Operatorid and store the index of the first occurrence
        result.forEach((item, index) => {
          if (operatorCount[item.Operatorid]) {
            operatorCount[item.Operatorid]++;
          } else {
            operatorCount[item.Operatorid] = 1;
            operatorFirstIndex[item.Operatorid] = index;
          }
        });

        result.forEach((item, index) => {
          if (operatorCount[item.Operatorid] > 1 && index !== operatorFirstIndex[item.Operatorid]) {
            item.Operatorid = 0;
          }
        });

        if (opert.length !== 0) {
          const operatorMap = opert.reduce((map, op) => {
            if (!map[op.Operationid]) {
              map[op.Operationid] = [];
            }
            map[op.Operationid].push(op.Operatorid);
            return map;
          }, {});

          console.log(operatorMap, 'operatorMap');
          const updatedDetailCollection = result.map((detail) => {
            const operatorIds = operatorMap[detail.Operationid] || [];
            const operatorId = operatorIds.length > 0 ? operatorIds.shift() : detail.Operatorid; // Use shift to get and remove the first ID

            if (operatorIds.length > 0) {
              operatorMap[detail.Operationid] = operatorIds;
            } else {
              delete operatorMap[detail.Operationid];
            }

            return {
              ...detail,
              Operatorid: operatorId,
            };
          });

          const filteredUserdata = userData.filter(
            (user) => !updatedDetailCollection.some((item) => Number(item.Operatorid) === Number(user.UserAccessID))
          );
          //  console.log(filteredUserdata,userData,arryanew,'filteredUserdata')
          setUserData(filteredUserdata);

          for (const datavalue of updatedDetailCollection) {
            enterdata(datavalue);
          }
        } else {
          const filteredUserdata = userData.filter(
            (user) => !result.some((item) => Number(item.Operatorid) === Number(user.UserAccessID))
          );
          //  console.log(filteredUserdata,userData,arryanew,'filteredUserdata')
          setUserData(filteredUserdata);

          for (const datavalue of result) {
            enterdata(datavalue);
          }
        }
      });
  };

  const enterdata = (data) => {
    console.log(data);
    const arrays = [...InsertDataDetail]; // Initialize arrays with the current tableData
    const newEntrys = {
      Operation: data.OperationName,
      OperatorName: data.UserName,
      Pieces: 0,
      Headerhours: selectedHour,
      Unit: unitSelected.Unit_Id,
      CreatedBy: sessionStorage.getItem('UserID'),
      Operationid: data.Operationid,
      Operatorid: data.Operatorid,
      Srhid: Scrid,
      Srdid: data.Srdid,
      finalOperation: data.finalOperation,
    };

    // // Update tableData state
    setTableData((prevTableData) => [...prevTableData, newEntrys]);

    const newEntry = {
      Operationid: data.Operationid,
      Operatorid: data.Operatorid,
      Pieces: 0,
      Headerhours: selectedHour,
      Unit: unitSelected.Unit_Id,
      CreatedBy: sessionStorage.getItem('UserID'),
      Srhid: Scrid,
      Srdid: data.Srdid,
      finalOperation: data.finalOperation,
    };

    setInsertDataDetail((prevInsertDataDetail) => [...prevInsertDataDetail, newEntry]);

    arrays.push(newEntry);

    // console.log(arrays, 'arrays');

    //  const filterdatas = OperationDataOption.filter(
    //    (obj) => !arrays.some((obj1) => obj1.Operationid === obj.Operationid)
    //  );

    // console.log(filterdatas, 'OperationDataOption');
    //  setOperationDataOption(filterdatas);

    resetFields();
  };

  const handleDialogOpen = () => {
    // Validate inputs
    // if (!operationSelected || !userselected || !Pieces || !unitSelected) {
    //   setFieldErrors({
    //     operationSelected: !operationSelected,
    //     userselected: !userselected,
    //     Pieces: !Pieces,
    //     unitSelected: !unitSelected,
    //   });
    //   return;
    // }

    const GetPrevDetails = async () => {
      console.log(obSelected.Srhid, 'obSelected.Srhid');
      try {
        const res = await axios.instance.get(`GetPrevprdetail/${obSelected.Srhid}`, {
          headers: { Authorization: tokent, 'Content-Type': 'application/json' },
        });
        const datas = res.data;
        const arr = [];
        for (const data of datas) {
          arr.push(data.Operatorid);
        }
        //  console.log(datas,'GetPrevDetails')
        GetoneSRC(datas);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    handleExpansion();
    if (HoursData.filter((data) => data.prhrs === 'H12').length === 0) {
      console.log(
        HoursData.filter((data) => data.prhrs === 'H1'),
        'TESTTTT'
      );
      GetPrevDetails();
    } else {
      // toastr.error("alread done for this hours", `${selectedHour}`)
      alert(`already done for this hours`);
      // toastr.info('Are you the 6 fingered man?')
    }
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setOpGroupSelected({ op_group_name: 'All Groups' });
  };

  function handleDetailChange(index, field, value) {
    // console.log(typeof value, 'dtl');
    const updatedDetails = [...tableData];
    updatedDetails[index][field] = value;
    setTableData(updatedDetails);

    if (field === 'Operatorid') {
      const filtersedUserdata = AllUsersData.filter(
        (user) => !updatedDetails.some((item) => Number(item.Operatorid) === Number(user.UserAccessID))
      );
      setUserData(filtersedUserdata);
    }

    const updatedDetails1 = [...InsertDataDetail];
    updatedDetails[index][field] = value;
    setInsertDataDetail(updatedDetails1);
  }

  const handleFromDateChange = (event) => {
    setDate(event.target.value);
    if (event.target.value) {
      Gethours(Scrid, event.target.value);
    }
  };
  const [selectedHour, setSelectedHour] = React.useState('H1');

  const handleChange = (event) => {
    // setSelectedHour(event.target.value);
  };

  const GetAllSRC = async () => {
    setOpenLoader(true);
    try {
      const res = await axios.instance.get('/GetallSRC', {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      // setallRecordsData(res.data);
      const uniqueProducts = [];
      const srhNoSet = new Set();

      res.data.forEach((product) => {
        if (!srhNoSet.has(product.SrhNo)) {
          srhNoSet.add(product.SrhNo);
          uniqueProducts.push({ ...product });
        }
      });

      setallRecordsData(uniqueProducts);

      setOpenLoader(false);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const GetOperationBasedSRC = async (ids) => {
    setOpenLoader(true);
    setScrid(ids);
    try {
      const res = await axios.instance.get(`GetOperationBasedSRC/${ids}`, {
        headers: { Authorization: tokent, 'Content-Type': 'application/json' },
      });
      // setallRecordsData(res.data);
      // console.log(res.data.filter((obj)=>obj.Operationid ===  tableData.Operationid))

      setOperationDataOption(res.data);
      setOpenLoader(false);
      if (id) {
        console.log(res.data, 'datas');
        getonedetails(res.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const [expanded, setExpanded] = React.useState(true);

  const handleExpansion = () => {
    setExpanded((prevExpanded) => !prevExpanded);
  };
  return (
    <>
      <Snackbar
        style={{ marginTop: '45px' }}
        open={openAlert}
        autoHideDuration={3000}
        onClose={handleCloseAlert}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        TransitionComponent={(props) => <Slide {...props} direction={'right'} />}
      >
        <Alert onClose={handleCloseAlert} severity={alertType} variant="filled" sx={{ width: '100%' }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      <Container maxWidth={'xl'}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent={'space-between'}
          alignItems={'center'}
          spacing={2}
        >
          <Box>
            <Link to={'/dashboard/manage/pr_production'}>
              <Button variant="outlined" color="info" startIcon={<KeyboardBackspaceIcon />}>
                Back
              </Button>
            </Link>
          </Box>
          <Typography
            variant="h5"
            boxShadow={1}
            borderColor="#11235A"
            textAlign={'center'}
            borderRadius={1}
            pl={2}
            pr={1}
            color="white"
            sx={{
              borderTopLeftRadius: 50,
              borderBottomLeftRadius: 50,
              background: 'linear-gradient(to right, #314755, #26a0da);',
              boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px',
            }}
          >
            <Stack direction={'row'} justifyContent={'end'} alignItems={'center'} spacing={2} sx={{ p: 0 }}>
              <KeyboardDoubleArrowLeftIcon />
              <Typography variant="body2" color="white" className="font_style1">
                PR Production
              </Typography>
            </Stack>
          </Typography>
        </Stack>

        <Paper elevation={5} sx={{ my: 2, py: 1, background: 'initial' }}>
          <Accordion
            expanded={expanded}
            onChange={handleExpansion}
            disableGutters
            sx={{ borderTop: 'none', borderColor: 'black', backgroundColor: 'inherit' }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon style={{ color: '#36BA98' }} />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderTop: 'none' }}
            >
              <Typography variant="h6" color="#607d8b" textAlign={'left'} mx={2}>
                Style Rate Card Details
              </Typography>
            </AccordionSummary>

            <AccordionDetails sx={{ borderTop: 'none', py: 0, pb: 2, pl: 3 }}>
              <Divider sx={{ mb: 2 }} />
              <Box sx={{ width: '100%', mt: 1 }}>
                <form onSubmit={handleFormSubmit}>
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item md={4} xs={12}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          disabled={id}
                          options={allRecordsData}
                          getOptionLabel={(obj) => (obj ? `${obj.SrhNo} - ${obj.StyleDescription} ` : '')}
                          isOptionEqualToValue={((option, value) => option?.Srhid === value?.Srhid) ?? undefined}
                          renderInput={(params) => <TextField {...params} label="Select SRC Record" />}
                          value={obSelected}
                          onChange={(e, newValue) => {
                            if (tableData.length === 0) {
                              setObSelected(newValue);

                              // setScrid(newValue);
                              Gethours(newValue.Srhid, date);
                              setIdState(newValue.Srhid);
                            } else {
                              setOpenDelete(true);
                              setSCRValue(newValue);
                            }
                            setFieldErrors((prevFieldErrors) => ({
                              ...prevFieldErrors,
                              obSelected: !newValue,
                            }));
                          }}
                        />
                        {fieldErrors.obSelected && (
                          <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                            please select operation bulletin record
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <Autocomplete
                          size="small"
                          fullWidth
                          options={unitData}
                          getOptionLabel={(obj) => (obj ? obj.Unit_Name : '')}
                          isOptionEqualToValue={((option, value) => option?.Unit_Id === value?.Unit_Id) ?? undefined}
                          renderInput={(params) => <TextField {...params} label="Factory Unit" />}
                          value={unitSelected}
                          // disabled={tableData.length!==0}
                          onChange={(e, newValue) => {
                            setUnitSelected(newValue);
                            setFieldErrors((prevFieldErrors) => ({
                              ...prevFieldErrors,
                              unitSelected: !newValue,
                            }));
                          }}
                        />
                        {fieldErrors.unitSelected && (
                          <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                            Please select production unit
                          </Typography>
                        )}
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <FormControl size="small" fullWidth component="fieldset" required>
                        <TextField
                          fullWidth
                          size="small"
                          label="PR Date"
                          disabled={id}
                          type="date"
                          value={date}
                          onChange={handleFromDateChange}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <FormControl size="small" fullWidth>
                        <InputLabel id="demo-select-small-label">Hour</InputLabel>
                        <Select
                          fullWidth
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value={selectedHour}
                          label="hours"
                          disabled
                          onChange={handleChange}
                        >
                          <MenuItem value={'H1'}>Hour 1</MenuItem>
                          <MenuItem value={'H2'}>Hour 2</MenuItem>
                          <MenuItem value={'H3'}>Hour 3</MenuItem>
                          <MenuItem value={'H4'}>Hour 4</MenuItem>
                          <MenuItem value={'H5'}>Hour 5</MenuItem>
                          <MenuItem value={'H6'}>Hour 6</MenuItem>
                          <MenuItem value={'H7'}>Hour 7</MenuItem>
                          <MenuItem value={'H8'}>Hour 8</MenuItem>
                          <MenuItem value={'H9'}>Hour 9</MenuItem>
                          <MenuItem value={'H10'}>Hour 10</MenuItem>
                          <MenuItem value={'H11'}>Hour 11</MenuItem>
                          <MenuItem value={'H12'}>Hour 12</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                    {!id && (
                      <>
                        <Grid item xs={12} md={1}>
                          <Button
                            variant="contained"
                            color="warning"
                            disabled={tableData.length !== 0}
                            onClick={handleDialogOpen}
                            fullWidth
                          >
                            Add
                          </Button>
                        </Grid>
                      </>
                    )}
                    {obSelected === null && (
                      <Stack
                        direction={'row'}
                        sx={{ width: '100%' }}
                        justifyContent={'center'}
                        alignItems={'center'}
                        spacing={2}
                      >
                        <img
                          src={noimge}
                          style={{ objectFit: 'contain', maxWidth: '30%', mixBlendMode: 'multiply' }}
                          alt="techveel logo"
                        />
                      </Stack>
                    )}
                  </Grid>
                </form>
              </Box>

              {obSelected !== null && (
                <>
                  <Divider sx={{ mt: 2 }} />
                  <Grid container spacing={2} rowSpacing={2} columnSpacing={2}>
                    <Grid item md={12}>
                      <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'center'}
                        p={2}
                        rowSpacing={1}
                        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                      >
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              SRC Reference :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688">
                              {headerData?.SrhNo}
                            </Typography>
                          </Stack>
                        </Grid>

                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              Style Description :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688">
                              {headerData?.StyleDescription}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" pr={1}>
                              Style Number :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688" textTransform={'capitalize'}>
                              {headerData?.StyleNumber}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" sx={{ whiteSpace: 'nowrap' }} pr={1}>
                              Batch or Line :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688">
                              {headerData?.Line_Name}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" sx={{ whiteSpace: 'nowrap' }} pr={1}>
                              Hours :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688">
                              {HoursData.map((data) => data.prhrs).join(', ')}
                            </Typography>
                          </Stack>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Stack justifyContent={'flex-start'} direction={{ xs: 'column', md: 'row' }}>
                            <Typography variant="subtitle2" color="GrayText" sx={{ whiteSpace: 'nowrap' }} pr={1}>
                              Remarks :
                            </Typography>
                            <Typography variant="subtitle2" color="#009688">
                              {headerData?.remarks}
                            </Typography>
                          </Stack>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
            </AccordionDetails>
          </Accordion>
        </Paper>

        {obSelected !== null && (
          <>
            <Box
              sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', pt: 2 }}
            >
              <div>
                Mark as Closed
                <Checkbox
                  checked={FinalPr}
                  disabled={isDisabled}
                  onChange={() => {
                    setFinalPr(!FinalPr);
                  }}
                />
              </div>
            </Box>

            <TableContainer component={Paper} sx={{ backgroundColor: 'inherit' }} elevation={3}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <StyledTableHeader align="center">S.No</StyledTableHeader>
                    <StyledTableHeader align="left">Operation</StyledTableHeader>
                    <StyledTableHeader align="left">Operator</StyledTableHeader>
                    <StyledTableHeader align="center">Pieces</StyledTableHeader>
                    <StyledTableHeader align="center">Hour</StyledTableHeader>
                    {/* <StyledTableHeader align="center">Actions</StyledTableHeader> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.map((obj, index) => (
                    <TableRow
                      key={index}
                      hover
                      sx={{
                        backgroundColor: obj.finalOperation === 'Y' ? '#D6EFD8' : 'inherit',
                      }}
                    >
                      <TableCell align="center">{index + 1}</TableCell>
                      <TableCell align="left" sx={{ textTransform: 'capitalize' }} style={{ whiteSpace: 'nowrap' }}>
                        {obj.Operation}
                      </TableCell>
                      <TableCell align="left" sx={{ textTransform: 'capitalize' }} style={{ whiteSpace: 'nowrap' }}>
                        {/* {obj.OperatorName} */}

                        <Autocomplete
                          size="small"
                          id="operator"
                          fullWidth
                          options={userData}
                          getOptionLabel={(deg) => (deg ? deg.UserName : '')}
                          isOptionEqualToValue={
                            ((option, value) => option?.UserAccessID === value?.UserAccessID) ?? undefined
                          }
                          renderInput={(params) => <TextField {...params} />}
                          // value={obj.Operatorid}
                          value={
                            AllUsersData.find(
                              (datas) => Number(datas.UserAccessID) === Number(tableData[index].Operatorid)
                            ) || null
                          }
                          ref={autocompleteRef}
                          onChange={(e, newValue) => {
                            // setUserSelected(newValue);
                            // setFieldErrors((prevFieldErrors) => ({
                            //   ...prevFieldErrors,
                            //   userselected: !newValue,

                            // }));

                            const exists = tableData.some(
                              (obj) => Number(obj.Operatorid) === Number(newValue.UserAccessID)
                            );
                            console.log(exists, 'exists');
                            if (exists) {
                              console.log('error');

                              alert('Operator Already Selected');
                            } else {
                              // const filteredUserdataFil = userData.filter(user => Number(newValue.UserAccessID) !== Number(user.UserAccessID))
                              // setUserData(filteredUserdataFil)

                              handleDetailChange(index, 'Operatorid', Number(newValue.UserAccessID));
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell align="center" style={{ maxWidth: '100px' }}>
                        <TextField
                          id={`Pieces${index}`}
                          size="small"
                          fullWidth
                          onFocus={(e) => {
                            e.target.select();
                          }}
                          onKeyPress={(e) => {
                            // console.log(e.key === "Enter",index+1  , tableData.length-1 )
                            if (e.key === 'Enter' && index + 1 <= tableData.length - 1) {
                              document.getElementById(`Pieces${index + 1}`).focus();
                            }
                          }}
                          type="number"
                          value={obj.Pieces || ''}
                          onChange={(e) => {
                            // handleDetailChange(index, 'Pieces', e.target.value)
                            if (e.target.value === '' || Number(e.target.value) >= 0) {
                              handleDetailChange(index, 'Pieces', Number(e.target.value));
                            }
                          }}
                        />
                      </TableCell>
                      <TableCell align="center" style={{ maxWidth: '100px' }}>
                        {obj.Headerhours}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>

            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', pt: 2 }}>
              <Button
                onClick={handleFormSubmit}
                disabled={isDisabled}
                color="info"
                size="small"
                endIcon={<CheckCircleIcon />}
                variant="contained"
              >
                Submit
              </Button>
            </Box>
          </>
        )}
      </Container>

      {/* loader popup dialog box */}
      <Dialog
        open={openLoader}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <LinearProgress />
      </Dialog>

      {/* add oprations */}
      <Dialog open={dialogOpen} onClose={handleDialogClose} maxWidth="md" fullWidth>
        <DialogTitle>Select Operations</DialogTitle>
        <DialogContent>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <Autocomplete
                size="small"
                fullWidth
                options={[{ op_group_name: 'All Groups' }, ...opGroupData]}
                getOptionLabel={(obj) => (obj ? obj.op_group_name : '')}
                isOptionEqualToValue={(option, value) => option?.OP_group_id === value?.OP_group_id}
                renderInput={(params) => <TextField {...params} label="Operation Group" />}
                value={opGroupSelected}
                onChange={(e, newValue) => {
                  setOpGroupSelected(newValue);
                  setFieldErrors((prevFieldErrors) => ({
                    ...prevFieldErrors,
                    setOpGroupSelected: !newValue,
                  }));
                }}
              />
              {fieldErrors.setOpGroupSelected && (
                <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                  Please select your operation group
                </Typography>
              )}
            </FormControl>
          </Stack>
          <Stack my={3}>
            <FormControl size="small" fullWidth component="fieldset" required>
              <TextField
                type="text"
                variant="outlined"
                color="secondary"
                label="Search"
                size="small"
                onChange={(e) => setSearchTerm(e.target.value)}
                value={searchTerm}
              />
              {fieldErrors.setOpGroupSelected && (
                <Typography variant="caption" color="error" sx={{ m: 0.5, px: 1.5 }}>
                  Please select your operation group
                </Typography>
              )}
            </FormControl>
          </Stack>
          <TableContainer sx={{ maxHeight: 400 }}>
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell align="left">S.No</TableCell>
                  <TableCell>Operation</TableCell>
                  <TableCell>Group</TableCell>
                  <TableCell>Machine</TableCell>
                  <TableCell>Role</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredData.map((obj, index) => (
                  <TableRow key={index} hover>
                    <TableCell align="center">{index + 1}</TableCell>
                    <TableCell align="left">{obj.OperationName}</TableCell>
                    <TableCell align="left">{obj.op_group_name}</TableCell>
                    <TableCell align="left">{obj.Machine_name}</TableCell>
                    <TableCell align="left">{obj.emp_role === 'O' ? 'Operator' : 'Helper'}</TableCell>
                    <TableCell align="center" sx={{ padding: '0' }}>
                      <Checkbox
                        checked={selectedOperations.includes(obj.OperationId)}
                        onChange={() => handleCheckboxChange(obj.OperationId)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} color="secondary">
            Cancel
          </Button>
          {selectedOperations.length > 0 && (
            <Button onClick={handleAddOperations} color="primary">
              Add Selected
            </Button>
          )}
        </DialogActions>
      </Dialog>

      <Grid m={2}>
        {/* delete confirmation popup dialog box */}
        <Dialog
          open={openDelete}
          onClose={handleCloseDelete}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullScreen={fullScreen}
          fullWidth
          maxWidth="xs"
        >
          <DialogTitle id="alert-dialog-title">{'Are you sure want clear the record?'}</DialogTitle>
          <DialogActions>
            <Button variant="contained" autoFocus onClick={handleCloseDelete} color="primary">
              Cancel
            </Button>
            <Button variant="contained" onClick={() => handleDeleteConfirmed()} color="error" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </Grid>
    </>
  );
}
